/** Telefone brasileiro: 10 dígitos (fixo) ou 11 dígitos (celular, com o 9). */

const COMPRIMENTO_FIXO = 10;
const COMPRIMENTO_CELULAR = 11;

const MASCARA_FIXO = /^(\d{2})(\d{4})(\d{4})$/;
const MASCARA_CELULAR = /^(\d{2})(\d{5})(\d{4})$/;

/**
 * Remove tudo que não for dígito.
 *
 * O comprimento válido (10 ou 11) é verificado por {@link validarTelefone} —
 * aqui o valor parcial é preservado para permitir digitação progressiva.
 */
export function normalizarTelefone(valor: string): string {
  return valor.replace(/\D/g, '');
}

/**
 * Valida um telefone: 10 ou 11 dígitos, DDD entre 11 e 99 e, quando houver 11
 * dígitos, o terceiro precisa ser `9`.
 */
export function validarTelefone(valor: string): boolean {
  const telefone = normalizarTelefone(valor);

  if (telefone.length !== COMPRIMENTO_FIXO && telefone.length !== COMPRIMENTO_CELULAR) {
    return false;
  }

  const ddd = Number(telefone.slice(0, 2));
  if (ddd < 11 || ddd > 99) return false;

  if (telefone.length === COMPRIMENTO_CELULAR && telefone.charAt(2) !== '9') return false;

  return true;
}

/**
 * Formata como `(00) 0000-0000` (10 dígitos) ou `(00) 00000-0000` (11 dígitos).
 *
 * Em qualquer outro comprimento devolve o valor normalizado sem máscara.
 */
export function formatarTelefone(valor: string): string {
  const telefone = normalizarTelefone(valor);
  if (telefone.length === COMPRIMENTO_FIXO) return telefone.replace(MASCARA_FIXO, '($1) $2-$3');
  if (telefone.length === COMPRIMENTO_CELULAR) {
    return telefone.replace(MASCARA_CELULAR, '($1) $2-$3');
  }
  return telefone;
}
